export interface Disc {
  x: number;
  y: number;
  vx: number;
  vy: number;
  color: "white" | "black" | "red" | "striker";
  pocketed: boolean;
  r: number;
}

export interface CarromGame {
  discs: Disc[];
  striker: Disc;
  turn: 1 | 2;
  scores: [number, number];
  aimAngle: number;
  power: number;
  inMotion: boolean;
  winner: number | null;
  message: string;
}

export const BOARD_W = 400;
export const BOARD_H = 400;
export const BOARD_L = 340;
export const DISC_R = 10;
export const STRIKER_R = 12;
export const CENTER = { x: BOARD_W / 2, y: BOARD_H / 2 };
export const POCKET_R = 18;

export const POCKETS = [
  { x: 30, y: 30 }, { x: BOARD_W - 30, y: 30 },
  { x: 30, y: BOARD_H - 30 }, { x: BOARD_W - 30, y: BOARD_H - 30 },
  { x: BOARD_W / 2, y: 20 }, { x: BOARD_W / 2, y: BOARD_H - 20 },
  { x: 20, y: BOARD_H / 2 }, { x: BOARD_W - 20, y: BOARD_H / 2 },
];
